<div class="signin-bg">
  <div class="signin-layout">
    <!-- Left Side - Login Form -->
    <div class="signin-left">
      <div class="signin-left-content">
        <div class="signin-header">
          <div class="signin-logo-wrapper">
            <img src="../../../../assets/images/logo_large.svg" alt="Logo" class="signin-logo" loading="lazy">
          </div>
          <p class="signin-subtitle">Sign in to access your admin control center</p>
        </div>

        <div class="signin-card">
          <form [formGroup]="loginForm" class="signin-form">
            <div class="form-header">
              <h2 class="form-title">Sign In</h2>
              <p class="form-description">Enter your credentials to continue</p>
            </div>

            <div class="form-group">
              <label for="emailInput" class="form-label">
                <span>Email Address</span>
              </label>
              <div class="input-wrapper">
                <input 
                  type="email" 
                  formControlName="email" 
                  class="form-control" 
                  id="emailInput" 
                  placeholder="name@example.com"
                  autocomplete="email"
                >
              </div>
              <div *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)" class="error-message">
                <span *ngIf="loginForm.controls['email'].errors?.required">
                  Email is required
                </span>
                <span *ngIf="loginForm.controls['email'].errors?.pattern">
                  Please enter a valid email address
                </span>
              </div>
            </div>

            <div class="form-group">
              <label for="passwordInput" class="form-label">
                <span>Password</span>
              </label>
              <div class="input-wrapper password-wrapper">
                <input 
                  [type]="show ? 'text' : 'password'" 
                  formControlName="password" 
                  class="form-control" 
                  id="passwordInput" 
                  placeholder="Enter your password"
                  autocomplete="current-password"
                >
                <button 
                  type="button"
                  (click)="password()" 
                  class="password-toggle" 
                  [attr.aria-label]="show ? 'Hide password' : 'Show password'"
                >
                  <img 
                    *ngIf="!show" 
                    src="../../../../assets/images/hide.png" 
                    alt="Show Password" 
                    loading="lazy"
                  >
                  <img 
                    *ngIf="show" 
                    src="../../../../assets/images/view.png" 
                    alt="Hide Password" 
                    loading="lazy"
                  >
                </button>
              </div>
              <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)" class="error-message">
                <span *ngIf="loginForm.controls['password'].errors?.required">
                  Password is required
                </span>
                <span *ngIf="loginForm.controls['password'].errors?.minlength">
                  Password must be at least 6 characters
                </span>
              </div>
            </div>

            <div class="form-actions">
              <button 
                type="button"
                class="btn btn-primary" 
                [disabled]="!loginForm.valid || isLoading" 
                (click)="login()"
              >
                <span *ngIf="!isLoading">Sign In</span>
                <span *ngIf="isLoading">Signing In...</span>
              </button>
            </div>
          </form>
        </div>

        <div class="signin-footer">
          <p class="footer-text">Secure Admin Portal</p>
        </div>
      </div>
    </div>

    <!-- Right Side - Content -->
    <div class="signin-right">
      <div class="signin-right-content">
        <div class="content-wrapper">
          <div class="content-header">
            <h2 class="content-title">Manage Everything in One Place</h2>
            <p class="content-subtitle">Your comprehensive admin control center</p>
          </div>

          <div class="features-list">
            <div class="feature-item">
              <div class="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#E1C16E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="feature-content">
                <h3 class="feature-title">Secure Access</h3>
                <p class="feature-description">Enterprise-grade security with encrypted authentication</p>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z" stroke="#E1C16E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2.90527 20.2491C3.82724 18.6531 5.15328 17.327 6.69632 16.405C8.23936 15.483 9.93848 15 11.6619 15C13.3853 15 15.0844 15.483 16.6275 16.405C18.1705 17.327 19.4966 18.6531 20.4185 20.2491" stroke="#E1C16E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="feature-content">
                <h3 class="feature-title">User Management</h3>
                <p class="feature-description">Efficiently manage users, roles, and permissions</p>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 19C9 19.5304 9.21071 20.0391 9.58579 20.4142C9.96086 20.7893 10.4696 21 11 21H13C13.5304 21 14.0391 20.7893 14.4142 20.4142C14.7893 20.0391 15 19.5304 15 19V7H9V19ZM17 4H14.5L13.5 3H10.5L9.5 4H7V6H17V4Z" stroke="#E1C16E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="feature-content">
                <h3 class="feature-title">Real-time Analytics</h3>
                <p class="feature-description">Monitor performance with live dashboards and reports</p>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#E1C16E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 6V12L16 14" stroke="#E1C16E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="feature-content">
                <h3 class="feature-title">24/7 Support</h3>
                <p class="feature-description">Round-the-clock assistance whenever you need it</p>
              </div>
            </div>
          </div>

          <div class="content-footer">
            <div class="stats-container">
              <div class="stat-item">
                <div class="stat-number">99.9%</div>
                <div class="stat-label">Uptime</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">1000+</div>
                <div class="stat-label">Active Users</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">24/7</div>
                <div class="stat-label">Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
        